
function rejectRequestDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/reject-request/reject-request-dialog.html?$$REVISION$$'
  }
}
export { rejectRequestDialog }
